<template>
  <v-form>
    <v-card>
      <v-card-text
        class="pt-4"
        style="position: relative;"
      >
        <v-container>
          <v-layout v-if="loading" align-center justify-center column >
            <v-progress-circular
              size="24"
              color="info"
              indeterminate
            ></v-progress-circular>
          </v-layout>
          <template v-else-if="frentista_model.pessoa">
              <v-layout align-center justify-center column >
                <v-avatar
                  color="grey"
                  size="60">
                    <img v-if="frentista_model.pessoa.url_imagem_perfil" :src="frentista_model.pessoa.url_imagem_perfil" alt="trevor">
                    <v-icon dark v-else>face</v-icon>
                </v-avatar>
              </v-layout>
              <v-layout align-center justify-center column >
                <v-card-title  class="text-xs-center">
                  <v-layout column align-center>
                    <div class="headline">{{ frentista_model.pessoa.nome }}</div>
                    <div>{{ frentista_model.pessoa.email }}</div>
                    <div>Tel: {{ frentista_model.pessoa.telefone }}</div>
                  </v-layout>
                </v-card-title>
              </v-layout>
          </template>
          <template v-else>
            <v-layout align-center justify-center column >
              <v-fade-transition leave-absolute>
                <v-avatar
                  color="transparent"
                  size="120">
                  <img :src="require('@/assets/logomarca.png')" alt="trevor">
                </v-avatar>
              </v-fade-transition>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="frentista_model.email"
                  outline
                  clearable
                  label="Email do frentista"
                  type="text"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="frentista_model.telefone"
                  outline
                  clearable
                  label="Telefone"
                  type="text"
                  mask="(##) # ####-####"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && frentista_model && frentista_model.pessoa && verificacaoTelefone.pessoa.id_pessoa !=  frentista_model.pessoa.id_pessoa)">
              <v-card class="ma-2" elevation="4">
                <v-card-title class="justify-center">
                  <h4
                    v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                    class="text-xs-center error--text"
                  >
                    Esse telefone já foi cadastrado
                  </h4>
                </v-card-title>
                <v-card-text>
                  <v-flex
                    class="error--text"
                    v-if="verificacaoTelefone.quantidade > 0"
                  >
                    {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                  </v-flex>
                  <v-flex
                    class="error--text"
                    v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                  >
                    IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                      {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                    </span>
                  </v-flex>
                  <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                    <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                    <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                    <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                    <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                    <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </template>
        </v-container>
      </v-card-text>
      <v-card-actions class="primary">
          <v-btn v-if="loading" disabled block flat dark>
          Aguarde o processamento ...
          </v-btn>
          <v-btn v-else-if="frentista_model.pessoa" flat block dark @click.prevent="() => conectarFrentista()">
              Conectar
          </v-btn>
          <v-btn v-else flat block dark @click.prevent="() => cadastrarAcessoFrentista()">
              Cadastrar
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  props: ['posto', 'frentista'],
  data () {
    return {
      testingThereIsPersonWithCPF: true,
      valid: true,
      frentista_model: {
        email: '',
        pessoa: null,
        telefone: ''
      },
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      }
    }
  },
  computed: {
    loading () {
      return this.testingThereIsPersonWithCPF
    }
  },
  methods: {
    cadastrarAcessoFrentista () {
      this.$store.dispatch('cadastrarUsuarioFrentista', {
          ...this.frentista_model,
          id_frentista: this.frentista.id_frentista,
          cnpj: this.posto.cnpj
        }).then((json) => {
        this.$emit('complete')
      }).catch((e) => {
        alert(e.message)
      })
    },
    conectarFrentista () {
      this.$store.dispatch('editarFrentista', {
          id_pessoa: this.frentista_model.pessoa.id_pessoa,
          id_frentista: this.frentista.id_frentista
      }).then((json) => {
        this.$emit('complete')
      }).catch((e) => {
        alert(e.message)
      })
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: this.frentista_model.pessoa ? this.frentista_model.pessoa.id_pessoa : null,
        filtros: this.frentista_model.email ? { email: this.frentista_model.email } : undefined,
        telefone: this.frentista_model.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    }
  },
  watch: {
    'frentista_model.telefone' (val) {
      if (val && val.length === 11) {
        this.verificarTelefone()
      } else {
        this.verificacaoTelefone.pessoa = undefined
        this.verificacaoTelefone.ids_cadastrados = []
        this.verificacaoTelefone.cadastrado = false
        this.verificacaoTelefone.quantidade = 0
      }
    },
    'frentista_model.email' (val) {
      if (val && this.frentista_model.telefone && this.frentista_model.telefone.length === 11) {
        this.verificarTelefone()
      } else {
        this.verificacaoTelefone.pessoa = undefined
        this.verificacaoTelefone.ids_cadastrados = []
        this.verificacaoTelefone.cadastrado = false
        this.verificacaoTelefone.quantidade = 0
      }
    }
  },
  mounted () {
    this.$store.dispatch('consultarFrentistaCPF', this.frentista.cpf).then((json) => {
      this.frentista_model.pessoa = json
      this.testingThereIsPersonWithCPF = false
    }).catch(() => {
      this.testingThereIsPersonWithCPF = false
    })
  }
}
</script>
